import { z } from "zod"
import { ContainerOptionsV1 } from "../containerOptions"

// Version 1 ---------------------
export const TimelineItemSettingsV1 = z.object({
  bulletRadius: z.number().int(),
  checkmarkIcon: z.string(),
  contentStyle: z.string(),
  gutterWidth: z.string(),
  hideIcons: z.union([z.literal(true), z.literal(false)]),
  iconContainerShadow: z.string(),
  iconContainerWidth: z.number().int(),
  iconUrl: z.string(),
  iconWidth: z.number().int(),
  isLast: z.union([z.literal(true), z.literal(false)]),
  isStepCompleted: z.union([z.literal(true), z.literal(false)]),
  primaryColor: z.string(),
  secondaryColor: z.string(),
  showCheck: z.union([z.literal(true), z.literal(false)]),
  style: z.string(),
  subtitleStyle: z.string(),
  trailStyle: z.string(),
})

export type TTimelineItemSettingsV1 = z.infer<typeof TimelineItemSettingsV1>

export const TimelineItemElementV1 = z.object({
  id: z.string(),
  name: z.literal("timelineItem"),
  settings: TimelineItemSettingsV1,
  container: ContainerOptionsV1,
})

export type TTimelineItemElementV1 = z.infer<typeof TimelineItemElementV1>

export const TimelineElementV1 = z.object({
  id: z.string(),
  name: z.literal("timeline"),
  container: ContainerOptionsV1,
  children: z.array(TimelineItemElementV1),
})

export type TTimelineElementV1 = z.infer<typeof TimelineElementV1>

// Latest ---------------------
export const TimelineItemSettings = TimelineItemSettingsV1
export type TTimelineItemSettings = TTimelineItemSettingsV1
export const TimelineItemElement = TimelineItemElementV1
export type TTimelineItemElement = TTimelineItemElementV1
export const TimelineElement = TimelineElementV1
export type TTimelineElement = TTimelineElementV1
